import React, { useState, useCallback } from "react";
import {
  Input,
  InputGroup,
  Row,
  Col,
  FormGroup,
  Label,
  Button,
  InputGroupAddon,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { DateField } from "../../../utils/FormFields";
import { debounce } from "../../../utils/Helper";
import { getProductTypeName, ProductType, OrderStatus } from "../../../utils";
import style from "../styles.module.scss";

const Toolbar = ({
  filter: rootFilter,
  filterText: rootFilterText,
  onChange: rootOnChange,
  onChangeText: rootOnChangeText,
  counters,
}) => {
  const [filters, setFilters] = useState(rootFilter);
  const [filterText, setFilterText] = useState(rootFilterText);

  const debounceCallback = useCallback(
    debounce((nextValues) => rootOnChange(nextValues), 500),
    []
  );

  const debounceCallbackText = useCallback(
    debounce((nextValues) => rootOnChangeText(nextValues), 500),
    []
  );

  const onChange = (fields) => {
    const nextValues = {
      ...filters,
      ...fields,
    };
    debounceCallback(nextValues);
    setFilters(nextValues);
  };

  const onChangeText = (text) => {
    debounceCallbackText(text);
    setFilterText(text);
  };

  return (
    <div className={style.toolbar}>
      <Row>
        <Counter total={counters.total} />
        <Col className="d-flex">
          <DateField
            label="From date"
            name="FromDate"
            onChange={(name, value) => onChange({ [name]: value })}
            value={filters.FromDate}
          />
        </Col>
        <Col className="d-flex">
          <DateField
            label="To date"
            name="ToDate"
            onChange={(name, value) => onChange({ [name]: value })}
            value={filters.ToDate}
          />
        </Col>
        <Col lg="4">
          <FormGroup>
            <Label>Global filter</Label>
            <InputGroup>
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <i className="fa fa-search"></i>
                </span>
              </div>

              <Input
                type="text"
                placeholder="Search something (use # before IDs)"
                value={filterText}
                onChange={(e) => onChangeText(e.target.value)}
              />
            </InputGroup>
          </FormGroup>
        </Col>
        <Col className="d-flex">
          <DropDownFilterProduct value={filters.Form} onChange={onChange} />
          <DropDownFilterStatus
            value={filters.Statuses}
            valueName={filters.StatusesName}
            onChange={onChange}
          />
        </Col>
        <Col className="d-flex">
          <div className={style.download}>
            {/* <Button color="primary" onClick={() => alert("ToDo!")}>
              <i className="fa fa-download"></i>
            </Button> */}
          </div>
        </Col>
      </Row>
    </div>
  );
};

const DropDownFilterStatus = ({ valueName, value, onChange }) => {
  const items = [
    { id: 0, description: "All Statuses", value: Object.values(OrderStatus) },
    {
      id: 1,
      description: "Working",
      value: [OrderStatus.PART, OrderStatus.ACKED],
    },
    { id: 2, description: "Routed", value: [OrderStatus.ROUTED] },
    { id: 3, description: "Parked", value: [OrderStatus.PARKED] },
    { id: 4, description: "Filled", value: [OrderStatus.FILLED] },
    { id: 5, description: "Part Filled", value: [OrderStatus.PART_FILLED] },
    { id: 6, description: "Rejected", value: [OrderStatus.REJECTED] },
    { id: 7, description: "Canceled", value: [OrderStatus.CANCELED] },
    { id: 8, description: "Expired", value: [OrderStatus.EXPIRED] },
    { id: 9, description: "Auth wait", value: [OrderStatus.AUTH_WAIT] },
    { id: 10, description: "Reallocating", value: [OrderStatus.REALLOCATING] },
  ];

  return (
    <UncontrolledDropdown>
      <DropdownToggle caret color="secondary" className={style.dropdown}>
        {value.length == 0 ? items[0].description : valueName}
      </DropdownToggle>
      <DropdownMenu>
        {items.map((item, index) => (
          <DropdownItem
            onClick={() =>
              onChange({
                StatusesName: item.description,
                Statuses: item.value,
              })
            }
            key={`status-${index}`}
          >
            {item.description}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

const DropDownFilterProduct = ({ onChange, value }) => {
  return (
    <UncontrolledDropdown>
      <DropdownToggle caret color="secondary" className={style.dropdown}>
        {value != "" ? getProductTypeName(value) : "All Products"}
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => onChange({ Form: "" })}>{"All Products"}</DropdownItem>
        {Object.values(ProductType).map((key, index) => (
          <DropdownItem onClick={() => onChange({ Form: key })} key={`product-${index}`}>
            {getProductTypeName(key)}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

const Counter = ({ total }) => (
  <Col lg="1" md="0" className="d-flex">
    <h6 className={"h6 page-title " + style.totals}>Orders: {total}</h6>
  </Col>
);

export default Toolbar;
